/**
 * inferSignupChannel — figure out which channel the visitor is browsing
 * from the current URL pathname. Used at signup/newsletter-subscribe
 * time so admin can segment audiences by League / Dreamers / FLYT.
 *
 *   /              → 'league'   (home channel)
 *   /stories/...   → 'league'
 *   /the-network…  → 'league'
 *   /visionary…    → 'dreamers'
 *   /dreamers/…    → 'dreamers'
 *   /flyt/…        → 'flyt'
 */
export default function inferSignupChannel() {
  if (typeof window === 'undefined') return 'league';
  const p = (window.location?.pathname || '').toLowerCase();
  if (p.startsWith('/flyt')) return 'flyt';
  if (p.startsWith('/visionary') || p.startsWith('/dreamers')) return 'dreamers';
  return 'league';
}
